export const GET_UPCOMMING_APPOITMENTS_START = "GET_UPCOMMING_APPOITMENTS_START"
export const GET_UPCOMMING_APPOITMENTS_SUCCESS = "GET_UPCOMMING_APPOITMENTS_SUCCESS"
export const GET_UPCOMMING_APPOITMENTS_FAILURE = "GET_UPCOMMING_APPOITMENTS_FAILURE"


export const REMOVE_ERROR_MESSAGE = "REMOVE_ERROR_MESSAGE"
